module.exports = __webpack_public_path__ + "static/media/Skin04.c2e9c45a.jpeg";